import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { AuthImage } from "./AuthImage";
import { Sparkles, ChevronRight } from "lucide-react";

export const OnThisDayWidget = () => {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/timeline/on-this-day");
        if (!cancelled) setItems(data || []);
      } catch (e) {
        // silently ignore
      } finally {
        if (!cancelled) setLoaded(true);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (!loaded || items.length === 0) return null;

  return (
    <section className="mb-12" data-testid="on-this-day-widget">
      <div className="flex items-end justify-between gap-4 mb-4">
        <div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-text_secondary mb-2 flex items-center gap-1.5">
            <Sparkles size={11} className="text-terracotta" /> Heute vor …
          </div>
          <h2 className="font-serif text-2xl sm:text-3xl text-ink leading-tight">
            Eure Erinnerung an diesem Tag
          </h2>
        </div>
        <Link to="/timeline" className="text-xs uppercase tracking-[0.2em] text-text_secondary hover:text-ink flex items-center gap-1" data-testid="on-this-day-see-all">
          Eure Geschichte <ChevronRight size={12} />
        </Link>
      </div>

      <div className="flex gap-4 overflow-x-auto scrollbar-hide pb-3 -mx-2 px-2">
        {items.map((item) => {
          const heroId = item.hero_image || (item.images && item.images[0]) || null;
          return (
            <article
              key={item.id}
              className="relative shrink-0 w-72 sm:w-80 aspect-[4/5] rounded-3xl overflow-hidden bg-ink"
              data-testid={`on-this-day-card-${item.id}`}
            >
              {heroId ? (
                <AuthImage fileId={heroId} size="medium" className="absolute inset-0 w-full h-full object-cover" alt={item.title} />
              ) : (
                <div className="absolute inset-0 bg-gradient-to-br from-terracotta/80 to-ink" />
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-black/0" />

              <div className="absolute top-5 left-5 right-5 flex items-center justify-between text-white">
                <div className="bg-white/20 backdrop-blur-md rounded-full px-3 py-1 text-[10px] uppercase tracking-[0.25em]">
                  Vor {item.years_ago} {item.years_ago === 1 ? "Jahr" : "Jahren"}
                </div>
              </div>

              <div className="absolute bottom-5 left-5 right-5 text-white">
                <h3 className="font-serif text-2xl leading-tight drop-shadow-sm">{item.title}</h3>
                {item.completed_at && (
                  <div className="text-xs opacity-90 mt-1">
                    {new Date(item.completed_at).toLocaleDateString("de-DE", { day: "2-digit", month: "long", year: "numeric" })}
                  </div>
                )}
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default OnThisDayWidget;
